import { fcmToken } from "../../@apis/v1/auth.service";
import { useDeviceStore } from "../store/useDeviceStore";

interface PushData {
  token: string;
}

declare global {
  interface Window {
    handlePushToServer: (jsonData: PushData) => void;
  }
}

window.handlePushToServer = (jsonData: PushData): void => {
  try {
    const { token } = jsonData as PushData;
    const { deviceType } = useDeviceStore.getState();

    if (token) {
      fcmToken({ deviceType, fcmToken: token }).then((res) => {
        if (res.success) {
          /* empty */
        } else {
          console.error("저장 API 실패");
        }
      });
    } else {
      console.error("token을 제대로 받지 못했습니다.");
    }
  } catch (error) {
    console.error(error, "데이터 이슈가 있습니다.");
  }
};

export {};
